'use client'

import { useEffect } from 'react'
import { gsapSetup } from '@/lib/animations/gsapSetup'

export default function GSAPProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    gsapSetup()
  }, [])

  return <>{children}</>
}
